import React, { useState } from "react";
import axios from "../../axios/axios";
import { cookies } from "../../axios/axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const user = cookies.get("user");

const FreeTrial = () => {
  const navigate = useNavigate();

  const [file, setFile] = useState(null);

  const onFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    if (selectedFiles.length < 1 || selectedFiles.length > 5) {
      toast.error("You must upload between 1 and 5 images.");
      return;
    }

    setFile(selectedFiles);
  };

  const [trial, setTrial] = useState({
    title: "",
    description: "",
    service: "",
  });

  const trialHandler = (e) => {
    const { name, value } = e.target;
    setTrial({ ...trial, [name]: value });
  };

  const addTrial = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", trial.title);
    formData.append("description", trial.description);
    formData.append("service", trial.service);

    if (file.length > 0) {
      file.forEach((f) => formData.append("files", f));
    }

    try {
      const response = await axios.post("/trial", formData);
      if (response.data) {
        toast.success("Trial Added");
        window.location.href = "/";
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <>
      <Navbar />
      {user ? (
        <div className="col-md-6 container mt-5">
          <form onSubmit={addTrial}>
            <h3 className="text-center fw-bold prata-regular mb-4">
              Free Trial
            </h3>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
            <div class="mb-3">
              <input
                onChange={trialHandler}
                name="title"
                value={trial.title}
                type="text"
                placeholder="Title *"
                class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                id="exampleInputFirstName1"
                aria-describedby="emailHelp"
              />
            </div>

            <div className="mb-3">
              <input
                onChange={onFileChange}
                type="file"
                multiple
                accept="image/*"
                className="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
              />
            </div>

            <div class="mb-3">
              <input
                onChange={trialHandler}
                name="description"
                value={trial.description}
                type="text"
                placeholder="Description *"
                class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
              />
            </div>
            <div className="mb-3">
              <select
                onChange={trialHandler}
                name="service"
                value={trial.service}
                className="form-select w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
              >
                <option value="">Select Service</option>
                <option value="Color Correction">Color Correction</option>
                <option value="Culling">Culling</option>
                <option value="Video Editing">Video Editing</option>
                <option value="Album Design">Album Design</option>
                <option value="Smart Album">Smart Album</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Retouching">Retouching</option>
              </select>
            </div>

            <button
              type="submit"
              name="submit"
              class="btn bg_maincolor text-light"
            >
              Add Trial
            </button>
          </form>
        </div>
      ) : (
        // alert("Login To Get A Free Trial.");
        // (navigate("/login"))
        (window.location.href = "/login")
      )}
      <Footer />
    </>
  );
};

export default FreeTrial;
